import { render, staticRenderFns } from "./ProjectsLogos.vue?vue&type=template&id=59174768"
import script from "./ProjectsLogos.vue?vue&type=script&lang=js"
export * from "./ProjectsLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports